export default [
  {
    label: '体重',
    options: [
      {
        label: '不足',
        data: [],
        key: 'weight_verylow_ratio',
        backgroundColor: '#6f42c1',
      },
      {
        label: '低い',
        data: [],
        key: 'weight_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'weight_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '高い',
        data: [],
        key: 'weight_high_ratio',
        backgroundColor: '#ffc107',
      },
      {
        label: '超過',
        data: [],
        key: 'weight_veryhigh_ratio',
        backgroundColor: '#f86c6b',
      },
    ],
  },
  {
    label: '体脂肪率',
    options: [
      {
        label: '低い',
        data: [],
        key: 'body_fat_rate_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'body_fat_rate_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '高い',
        data: [],
        key: 'body_fat_rate_high_ratio',
        backgroundColor: '#ffc107',
      },
      {
        label: '超過',
        data: [],
        key: 'body_fat_rate_veryhigh_ratio',
        backgroundColor: '#f86c6b',
      },
    ],
  },
  {
    label: '体水分率',
    options: [
      {
        label: '低い',
        data: [],
        key: 'body_water_rate_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'body_water_rate_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '十分',
        data: [],
        key: 'body_water_rate_high_ratio',
        backgroundColor: '#a8cf6a',
      },
    ],
  },
  {
    label: '基礎代謝',
    options: [
      {
        label: '低い',
        data: [],
        key: 'BMR_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '高い',
        data: [],
        key: 'BMR_high_ratio',
        backgroundColor: '#ffc107',
      },
    ],
  },
  {
    label: '体内年齢',
    options: [
      {
        label: '低い',
        data: [],
        key: 'metabolic_age_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '高い',
        data: [],
        key: 'metabolic_age_high_ratio',
        backgroundColor: '#ffc107',
      },
    ],
  },
  {
    label: '骨格筋',
    options: [
      {
        label: '低い',
        data: [],
        key: 'muscle_rate_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'muscle_rate_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '高い',
        data: [],
        key: 'muscle_rate_high_ratio',
        backgroundColor: '#ffc107',
      },
    ],
  },
  {
    label: '骨量',
    options: [
      {
        label: '低い',
        data: [],
        key: 'bone_mass_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'bone_mass_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '高い',
        data: [],
        key: 'bone_mass_high_ratio',
        backgroundColor: '#ffc107',
      },
    ],
  },
  {
    label: '皮下脂肪',
    options: [
      {
        label: '低い',
        data: [],
        key: 'subcutaneous_fat_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'subcutaneous_fat_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '高い',
        data: [],
        key: 'subcutaneous_fat_high_ratio',
        backgroundColor: '#ffc107',
      },
    ],
  },
  {
    label: '内臓脂肪',
    options: [
      {
        label: '標準',
        data: [],
        key: 'visceral_fat_low_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '高い',
        data: [],
        key: 'visceral_fat_standard_ratio',
        backgroundColor: '#ffc107',
      },
      {
        label: '超過',
        data: [],
        key: 'visceral_fat_high_ratio',
        backgroundColor: '#f86c6b',
      },
    ],
  },
  {
    label: 'BMI',
    options: [
      {
        label: '低い',
        data: [],
        key: 'BMI_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'BMI_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '高い',
        data: [],
        key: 'BMI_high_ratio',
        backgroundColor: '#ffc107',
      },
    ],
  },
  {
    label: '総筋肉量',
    options: [
      {
        label: '低い',
        data: [],
        key: 'muscle_mass_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'muscle_mass_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '十分',
        data: [],
        key: 'muscle_mass_high_ratio',
        backgroundColor: '#a8cf6a',
      },
    ],
  },
  {
    label: 'タンパク質',
    options: [
      {
        label: '低い',
        data: [],
        key: 'protein_low_ratio',
        backgroundColor: '#20a8d8',
      },
      {
        label: '標準',
        data: [],
        key: 'protein_standard_ratio',
        backgroundColor: '#4dbd74',
      },
      {
        label: '十分',
        data: [],
        key: 'protein_high_ratio',
        backgroundColor: '#a8cf6a',
      },
    ],
  },
]
